"use client";
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faYoutube, faLinkedin, faTiktok, faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import logoImg1 from '../../public/images/logoSICONSPERU1.png';
import logoImg2 from '../../public/images/CIGEBI.png';
import logoImg3 from '../../public/images/Value-Added-Reseller-2.png';

const LogoBanner = () => {
  const socialMedia = [
    {
      name: "whatsapp",
      url: "https://wa.me/51937712155?text=Hola,%20necesito%20ayuda",
      icon: faWhatsapp,
    },
    {
      name: "youtube",
      url: "https://www.youtube.com/@siconsperu",
      icon: faYoutube,
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/company/siconsperu",
      icon: faLinkedin,
    },

  {
      name: "facebook",
      url: "https://www.facebook.com/siconsperu",
      icon: faFacebook,
    },
    {
      name: "instagram",
      url: "https://www.instagram.com/siconsperu/",
      icon: faInstagram,
    },
    {
      name: "tiktok",
      url: "https://www.tiktok.com/@siconsperu",
      icon: faTiktok,
    }    
  ];

  return (
    <div className="bg-white py-4 shadow-md animate-fade-in">
      <div className="max-w-7xl mx-auto px-8 flex justify-between items-center">

        {/* Logo Izquierdo */}
        <Link href="/">
          <div className="relative w-[200px] h-[40px]">
            <Image
              src={logoImg1}
              alt="Logo SICONSPERU1"
              layout="fill"
              objectFit="contain"
            />
          </div>
        </Link>

        {/* Íconos de Redes Sociales */}
        <div className="flex items-center space-x-4">
          {socialMedia.map((item) => (
            <Link key={item.name} href={item.url} className={`social-icon ${item.name}`}>
              <FontAwesomeIcon icon={item.icon} size="lg" />
            </Link>
          ))}
        </div>

        {/* Logo Derecho 1*/}
         <Link href="/">
          <div className="relative w-[200px] h-[40px]">
            <Image
              src={logoImg2}
              alt="Logo SICONSPERU2"
              layout="fill"
              objectFit="contain"
            />
          </div>
        </Link>

        {/* Logo Derecho 2*/}
          <Link href="/">
          <div className="relative w-[200px] h-[40px]">
            <Image
              src={logoImg3}
              alt="Logo ZOHO"
              layout="fill"
              objectFit="contain"
            />
          </div>
        </Link>        
      </div>
    </div>
  );
};

export default LogoBanner;